import React, { useState, useRef } from "react";
import * as XLSX from "xlsx";


function BulkUploadItems() {
    const BASE_URL = process.env.REACT_APP_PP_URL;
    const token = sessionStorage.getItem('tokenKey');

    const [file, setFile] = useState(null);
    const [dragOver, setDragOver] = useState(false);
    const [uploading, setUploading] = useState(false);
    const [uploadStatus, setUploadStatus] = useState(null);
    const fileInputRef = useRef(null);

    const downloadSampleExcel = () => {
        const sampleData = [
            { Title: "Sample Item", ItemCode: "ITM001", MRP: "500", SellingPrice: "450", Category: "Electronics" },
        ];
        const worksheet = XLSX.utils.json_to_sheet(sampleData);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Items");
        XLSX.writeFile(workbook, "Items_Sample.xlsx");
    };

    const handleDrop = (e) => {
        e.preventDefault();
        setDragOver(false);
        const dropped = e.dataTransfer.files[0];
        if (dropped && (dropped.name.endsWith(".xlsx") || dropped.name.endsWith(".xls"))) {
            setFile(dropped);
            setUploadStatus(null);
        }
    };


    const handleFileChange = async (e) => {
        setFile(e.target.files[0]);
    };

    const handleUpload = async () => {
        if (!file) return;
        setUploading(true);
        setUploadStatus(null);
        const formData = new FormData();
        formData.append("file", file);
        try {
            const response = await fetch(`${BASE_URL}/admin/v1/item/bulkUpload`, {
                method: "POST",
                headers: { Authorization: `Bearer ${token}` },
                body: formData,
            });
            const data = await response.json();
            await new Promise((r) => setTimeout(r, 1500));
            if (data.errorCode === 0) {
                setUploadStatus("success");
            }
        } catch (error) {
            setUploadStatus("error");
        } finally {
            setUploading(false);
        }
    };

    const removeFile = () => {
        setFile(null);
        setUploadStatus(null);
        if (fileInputRef.current) fileInputRef.current.value = "";
    };

    return (
        <>


            <div className="bulk-root">

                <div className="bulk-header">
                    <div className="bulk-header-left">
                        <div className="bulk-header-icon">
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                                <path d="M12 16V8M12 8L9 11M12 8l3 3" stroke="#111111" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" />
                                <path d="M3 15v3a2 2 0 002 2h14a2 2 0 002-2v-3" stroke="#111111" strokeWidth="2.2" strokeLinecap="round" />
                            </svg>
                        </div>
                        <div>
                            <h4 className="bulk-title">Upload Bulk Items</h4>
                            <p className="bulk-subtitle">Import multiple items at once via Excel</p>
                        </div>
                    </div>
                    <button className="btn-sample" onClick={downloadSampleExcel}>
                        <svg width="15" height="15" viewBox="0 0 24 24" fill="none">
                            <path d="M12 3v13M7 11l5 5 5-5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                            <path d="M3 18h18" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
                        </svg>
                        Download Sample
                    </button>
                </div>

                <div className="upload-card">
                    <div className="upload-card-header">
                        <p className="upload-card-title">Upload Your Excel File</p>
                        <p className="upload-card-desc">Accepts .xlsx and .xls formats — up to 10 MB</p>
                    </div>
                    <div className="upload-card-body">

                        <div
                            className={`drop-zone ${dragOver ? "drag-over" : ""} ${file ? "has-file" : ""}`}
                            onDragOver={(e) => { e.preventDefault(); setDragOver(true); }}
                            onDragLeave={() => setDragOver(false)}
                            onDrop={handleDrop}
                            onClick={() => !file && fileInputRef.current?.click()}
                        >
                            <input ref={fileInputRef} type="file" accept=".xlsx,.xls" onChange={handleFileChange} style={{ display: "none" }} />
                            <div className="drop-zone-icon">
                                <svg width="26" height="26" viewBox="0 0 24 24" fill="none">
                                    <path d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8l-6-6z" stroke="#F5C518" strokeWidth="1.8" strokeLinejoin="round" />
                                    <path d="M14 2v6h6M8 13h8M8 17h5" stroke="#F5C518" strokeWidth="1.8" strokeLinecap="round" />
                                </svg>
                            </div>
                            {file ? (
                                <>
                                    <p className="drop-zone-title" style={{ color: "#F5C518" }}>File ready to upload</p>
                                    <p className="drop-zone-hint">Click × to choose a different file</p>
                                </>
                            ) : (
                                <>
                                    <p className="drop-zone-title">Drag & drop your file here</p>
                                    <p className="drop-zone-hint">or <span className="browse-link">browse files</span> from your computer</p>
                                    <div className="file-formats">
                                        <span className="format-tag">xlsx</span>
                                        <span className="format-tag">xls</span>
                                    </div>
                                </>
                            )}
                        </div>

                        {file && (
                            <div className="file-preview">
                                <div className="file-icon">
                                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                                        <path d="M9 17H7a2 2 0 01-2-2V5a2 2 0 012-2h10a2 2 0 012 2v3" stroke="#F5C518" strokeWidth="2" strokeLinecap="round" />
                                        <rect x="9" y="11" width="12" height="10" rx="2" stroke="#F5C518" strokeWidth="2" />
                                        <path d="M12 14h6M12 17h4" stroke="#F5C518" strokeWidth="1.6" strokeLinecap="round" />
                                    </svg>
                                </div>
                                <div className="file-info">
                                    <p className="file-name">{file.name}</p>
                                    <p className="file-size">{(file.size / 1024).toFixed(1)} KB</p>
                                </div>
                                <button className="remove-btn" onClick={removeFile} title="Remove file">
                                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
                                        <path d="M18 6L6 18M6 6l12 12" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
                                    </svg>
                                </button>
                            </div>
                        )}

                        {uploadStatus === "success" && (
                            <div className="status-banner success">
                                <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
                                    <circle cx="12" cy="12" r="10" stroke="#F5C518" strokeWidth="2" />
                                    <path d="M8 12l3 3 5-5" stroke="#F5C518" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                </svg>
                                Items uploaded successfully! Your catalog has been updated.
                            </div>
                        )}
                        {uploadStatus === "error" && (
                            <div className="status-banner error">
                                <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
                                    <circle cx="12" cy="12" r="10" stroke="#f87171" strokeWidth="2" />
                                    <path d="M12 8v4M12 16h.01" stroke="#f87171" strokeWidth="2" strokeLinecap="round" />
                                </svg>
                                Upload failed. Please check your file and try again.
                            </div>
                        )}

                        <button className="btn-upload" onClick={handleUpload} disabled={!file || uploading}>
                            {uploading ? (
                                <><div className="spinner" /> Uploading…</>
                            ) : (
                                <>
                                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                                        <path d="M12 16V8M12 8L9 11M12 8l3 3" stroke="#111111" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" />
                                        <path d="M3 15v3a2 2 0 002 2h14a2 2 0 002-2v-3" stroke="#111111" strokeWidth="2.2" strokeLinecap="round" />
                                    </svg>
                                    Upload File
                                </>
                            )}
                        </button>

                    </div>
                </div>
            </div>
        </>
    );
}

export default BulkUploadItems;